<template>
    <div class="ma-4">
      <v-snackbar v-model="msg" top>
        {{ text }}
        <v-btn color="pink" text  @click="msg = false">
          Close
        </v-btn>
      </v-snackbar>

      <StaffNav />

      <v-row>
        <v-col cols="12" lg="3" xl="2">
          <StaffSide/>
        </v-col>

        <v-col  cols="12" lg="9" xl="10">
          <v-data-table
            :headers="headers"
            :items="trainings"
            sort-by="Date"
            sort-desc
            class="elevation-1 "
            :loading="isLoading"
            loading-text="Loading Inservice Trainings"
            :search="search"
            height="550"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Inservice Training</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>

                <v-text-field
                  v-model="search"
                  clearable
                  flat
                  solo-inverted
                  hide-details
                  prepend-inner-icon="search"
                  label="search"
                  class="desktop"
                ></v-text-field>
                <v-spacer></v-spacer>

                <report-list-actions
                  :reportOptions="reportOptions"
                  :downloadFilename="reportListFilename"
                ></report-list-actions>

                <v-btn v-if="!isAuditorRole" color="#2b3990" class="mb-2 white--text" v-on="on" @click="showAdd()">
                  <v-icon left>add</v-icon>
                  Add Training
                </v-btn>

              </v-toolbar>
            </template>

            <template v-slot:item.Signature="{ item }">
              <v-icon
                  class="ma-2"
                  color="red"
                  x-small
                  v-if="!item.Signature"
                >
                close
              </v-icon>
              <v-icon
                  class="ma-2"
                  color="green"
                  x-small
                  v-if="item.Signature"
                >
                check
              </v-icon>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="viewTraining(item._id)">
                mdi-eye
              </v-icon>

              <v-icon v-if="!isAuditorRole" small @click="confirmDelete(item._id)">
                mdi-delete
              </v-icon>

            </template>
            <template v-slot:no-data>
              <v-btn color="#2b3990" class="white--text" @click="getTrainings()">Reset</v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </div>
</template>
<script>
import axios from 'axios'
import StaffNav from '@/components/StaffNav'
import StaffSide from '@/components/StaffSide'
import ReportListActions from '@/components/Report/ReportListActions.vue'
import DateTimeUtil from "../../../utils/date-time.util";

const url = require("../../client_config/config").url;

  export default {
  components: {
    StaffNav,
    StaffSide,
    ReportListActions
  },
    data: function() {
      return {
        headers: [
          {
            text: 'Training Date',
            align: 'start',
            sortable: true,
            value: 'Date',
          },
          { text: "Training Type", value: "TrainingType" },
          { text: "Training Subject", value: "TrainingSubject" },
          { text: "Training Description", value: "Description" },
          { text: "Time Started", value: "TimeStarted" },
          { text: "Total Hours", value: "Duration" },
          { text: "Staff Signature", value: "Signature" },
          { text: "Actions", value: "actions", sortable: false },
        ],
        trainings: [],
        isLoading: false,
        search: "",
        msg: false,
        text: "",
        employeeID: this.$route.params.employeeID,
        staffName: localStorage.getItem("Name"),
        on: false,
      };
    },

    created() {
      this.getTrainings();
    },

    computed: {

      selectedEmployee() {
        return this.$store.state.users.allUsers.find(
            (user) => user._id == this.employeeID
        )
      },

      reportOptions() {
        return {
          query: {
            name: this.staffName,
          },
          endpoints: `inserviceTraining/printList/${this.employeeID}`,
          dynamic: true
        }
      },
      reportListFilename() {
        return `${this.employeeName} - Trainings`
      },
      isAuditorRole() {
        return localStorage.getItem("userRole") === 'Auditor'
      }
    },

    methods: {
      getTrainings: function() {
        if (this.isLoading) return;

        this.isLoading = true;

        axios.get(`${url}/inserviceTraining/staff/${this.employeeID}`)
          .then(res => {
            this.trainings = res.data.trainings.map(training => ({
              ...training,
              Date: DateTimeUtil.toLocalDate(training.Date),
              TimeStarted: this.formatIfUTC(training.TimeStarted),
              TimeEnded: this.formatIfUTC(training.TimeEnded),
            }));
          })
          .finally(() => {
            this.isLoading = false;
          });
      },


      formatIfUTC(timeValue) {
        const isUTC = typeof timeValue === 'string' && timeValue.includes('T') && !timeValue.includes('AM') && !timeValue.includes('PM');

        if (!isUTC) return timeValue;

        const date = new Date(timeValue);
        let hours = date.getHours();
        const minutes = date.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';

        if (hours === 0) {
          hours = 12;
        } else if (hours > 12) {
          hours = hours % 12;
        }

        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}${ampm}`;
      },

      confirmDelete(id) {
        confirm("Are you sure you want to delete this training?") &&
        this.trainingDelete(id);
      },

      trainingDelete(id) {
        axios.delete(`${url}/inserviceTraining/${id}`)
        .then((response) => {
          this.getTrainings();
          if (response.status == 400) {
            response.json().then(function(data) {
              return data.msg;
            });
          }
          this.msg=true;
          this.text="The training has been deleted successfully.";
        });
      },

      showAdd() {
        this.$router.push({
          path: `/InserviceTraining/${this.employeeID}/add`,
        });
      },

      viewTraining(id) {
        this.$router.push({
          path: `/InserviceTraining/${this.employeeID}/edit/${id}`,
        });
      },
    }
  }
</script>
